import { defineStore } from "pinia"
import { useFirebase } from "@/composables/common/useFirebase"

export const useCookieConsentStore = defineStore("cookieConsent", {
	state: () => ({
		analyticsAccepted: null as boolean | null
	}),
	getters: {
		hasChosen(): boolean {
			return this.analyticsAccepted !== null
		}
	},
	actions: {
		setAnalyticsAccepted(accepted: boolean) {
			this.analyticsAccepted = accepted

			if (accepted) {
				useFirebase().initAnalytics()
			}
		}
	},
	persist: {
		pick: ["analyticsAccepted"]
	}
})
